// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhallPlayerh5-container .vhallPlayerh5-playBtn{\n  width: 16px;\n  height: 18px;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  display: block;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
